"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = void 0;
const react_1 = __importDefault(require("react"));
const evangelist_elements_icon_1 = require("@teambit/evangelist.elements.icon");
const design_ui_error_page_1 = require("@teambit/design.ui.error-page");
const design_ui_external_link_1 = require("@teambit/design.ui.external-link");
const not_found_page_module_scss_1 = __importDefault(require("./not-found-page.module.scss"));
function NotFoundPage(_a) {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(design_ui_error_page_1.ErrorPage, Object.assign({}, rest, { code: 404, title: "Page not found" }),
        react_1.default.createElement("div", { className: not_found_page_module_scss_1.default.iconLine },
            react_1.default.createElement(design_ui_external_link_1.ExternalLink, { href: "https://join.slack.com/t/bit-dev-community/shared_invite/zt-o2tim18y-UzwOCFdTafmFKEqm2tXE4w" },
                react_1.default.createElement("img", { alt: "bit-logo", className: not_found_page_module_scss_1.default.logo, src: "https://static.bit.dev/harmony/slack-round-icon.svg" })),
            react_1.default.createElement(design_ui_external_link_1.ExternalLink, { href: "https://github.com/teambit/bit" },
                react_1.default.createElement(evangelist_elements_icon_1.Icon, { of: "github-logo", className: not_found_page_module_scss_1.default.github })),
            react_1.default.createElement(design_ui_external_link_1.ExternalLink, { href: "https://harmony-docs.bit.dev/" },
                react_1.default.createElement("img", { alt: "bit-logo", className: not_found_page_module_scss_1.default.logo, src: "https://static.bit.dev/bit-logo.svg" })))));
}
exports.NotFoundPage = NotFoundPage;
//# sourceMappingURL=not-found-page.js.map